import { VIEWING_PROFILE_ACTION } from '../RentalPortalViewingProfile.constants'

import ArchiveIcon from '../../../../icons/delete.svg'
import NoteIcon from '../../../../icons/edit.svg'
import RestoreIcon from '../../../../icons/restore.svg'
import UploadIcon from '../../../../icons/upload-1.svg'
import ViewingIcon from '../../../../icons/viewing.svg'

export const QA_NAME_VIEWING_PROFILE_FOOTER_ADD_NEW = 'viewingProfileAddNew'

export const QA_NAME_VIEWING_PROFILE_FOOTER_MORE = 'viewingProfileActionMore'

export const VIEWING_PROFILE_FOOTER_ACTION_ITEMS = [
  {
    Icon: NoteIcon,
    action: VIEWING_PROFILE_ACTION.addNote,
  },
  {
    Icon: ViewingIcon,
    action: VIEWING_PROFILE_ACTION.reschedule,
  },
  {
    Icon: UploadIcon,
    action: VIEWING_PROFILE_ACTION.uploadDocument,
  },
  {
    // TODO: the icon set has no calendar glyph (Charter U7) — the action ships
    // text-only until the Design cleanup batch delivers one.
    action: VIEWING_PROFILE_ACTION.addToCalendar,
  },
  {
    action: VIEWING_PROFILE_ACTION.completed,
  },
  {
    action: VIEWING_PROFILE_ACTION.noShow,
  },
  {
    action: VIEWING_PROFILE_ACTION.cancel,
  },
]

export const VIEWING_PROFILE_FOOTER_ACTION_TEXT_KEY = {
  [VIEWING_PROFILE_ACTION.addNote]:
    'RentalPortal.ViewingProfileAddNoteActionKey',
  [VIEWING_PROFILE_ACTION.addToCalendar]:
    'RentalPortal.ViewingAddToCalendarKey',
  [VIEWING_PROFILE_ACTION.archive]:
    'RentalPortal.ViewingArchiveActionOptionKey',
  [VIEWING_PROFILE_ACTION.cancel]: 'RentalPortal.ViewingCancelActionKey',
  [VIEWING_PROFILE_ACTION.completed]: 'RentalPortal.ViewingCompletedActionKey',
  [VIEWING_PROFILE_ACTION.noShow]: 'RentalPortal.ViewingNoShowActionKey',
  [VIEWING_PROFILE_ACTION.reschedule]:
    'RentalPortal.ViewingRescheduleActionKey',
  [VIEWING_PROFILE_ACTION.restore]:
    'RentalPortal.ListingRestoreActionOptionKey',
  [VIEWING_PROFILE_ACTION.uploadDocument]:
    'RentalPortal.ViewingDocumentUploadBtnKey',
}

export const VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON = {
  [VIEWING_PROFILE_ACTION.archive]: ArchiveIcon,
  [VIEWING_PROFILE_ACTION.restore]: RestoreIcon,
}

export const VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME = {
  [VIEWING_PROFILE_ACTION.archive]: 'can_archive',
  [VIEWING_PROFILE_ACTION.restore]: 'can_restore',
}
